import React, { useEffect } from 'react';
import * as Scrivito from 'scrivito';

Scrivito.provideObjClass('RootPage', {
  attributes: {
    title: 'string',
    body: 'widgetlist',
    childOrder: 'referencelist',
  },
});

// RootPageController#index redirected to `Homepage.default`, i.e. the first
// homepage – the German one. Its browser-language variant
// (#redirect_to_language) was commented out in the Rails app, so picking the
// language from navigator.language served English to anyone whose browser asked
// for it, and made "/" non-deterministic. The child order the editors maintain
// decides instead.
const RootPageComponent = Scrivito.connect(({ page }) => {
  const homepages = page
    .orderedChildren()
    .filter((child) => child.objClass() === 'Homepage');
  const target =
    homepages[0] || Scrivito.Obj.where('_objClass', 'equals', 'Homepage').first();

  useEffect(() => {
    if (target) Scrivito.navigateTo(target);
  }, [target]);

  return (
    <div className="d-flex justify-content-center align-items-center" style={{ minHeight: '100vh' }}>
      <div className="spinner-border text-primary" role="status">
        <span className="visually-hidden">Loading…</span>
      </div>
    </div>
  );
});

Scrivito.provideComponent('RootPage', RootPageComponent);

export default RootPageComponent;
